import { type ReactNode, useState } from 'react'
import { buildRecordingFile as buildFile } from '../Components/VoiceRecording/buildRecording'
import type { RecordType } from '../Components/VoiceRecording/types'
import { ReportFormContext, ReportInputType } from './ReportFormContext'

type Props = {
  children: ReactNode
}

const ReportFormProvider = ({ children }: Props) => {
  const [victimPin, setVictimPin] = useState<string | null>(null)
  const [createdAt, setCreatedAt] = useState<Date | null>(null)
  const [recording, setRecording] = useState<RecordType | null>(null)
  const [tag, setTag] = useState<string | null>(null)
  const [isAnonymous, setIsAnonymous] = useState(true)
  const [reportInputType, setReportInputType] = useState(ReportInputType.Text)

  const buildRecordingFile = async () => {
    if (!recording) {
      return null
    }

    return buildFile(recording)
  }

  return (
    <ReportFormContext.Provider
      value={{
        victimPin,
        setVictimPin,
        createdAt,
        setCreatedAt,
        recording,
        setRecording,
        buildRecordingFile,
        tag,
        setTag,
        isAnonymous,
        setIsAnonymous,
        reportInputType,
        setReportInputType,
      }}
    >
      {children}
    </ReportFormContext.Provider>
  )
}

export default ReportFormProvider
